import React, { useState } from 'react';

const FAQ = () => {
  // FAQ data
  const faqs = [
    {
      id: 1,
      question: 'Can I track my fitness goals in the app?',
      answer: 'Yes! TheChamps lets you easily track all your goals.',
    },
    {
      id: 2,
      question: 'Are the workouts beginner friendly?',
      answer:
        'Absolutely. We offer multiple workout plans tailored to all levels',
    },
    {
      id: 3,
      question: 'Is the app available on the App Store?',
      answer:
        'Not yet! TheChamps is currently available as a fully functional web app. You can access it anytime at thechamps.app from your browser.',
    },
    {
      id: 4,
      question: 'How do I install or add "TheChamps" to my home screen?',
      answer:
        'On iOS, you can add TheChamps to your home screen by tapping the share icon in the browser and selecting "Add to Home Screen". On Android, you can add TheChamps to your home screen by tapping the three-dot menu in the browser and selecting "Add to home screen".',
    },
    {
      id: 5,
      question: 'Do I need equipment to do the workouts?',
      answer:
        'Nope! Many of our challenges are designed for home workouts with little to no equipment.',
    },
  ];

  // State to track which FAQ is open
  const [openId, setOpenId] = useState(null);

  // Toggle function to open/close FAQs
  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section
      className='py-20 bg-primary text-white'
      id='faq'
    >
      <div className='container mx-auto px-4 max-w-4xl'>
        <div className='text-center mb-16'>
          <h2 className='text-3xl md:text-4xl font-bold mb-4'>
            Frequently Asked Questions
          </h2>
          <p className='text-lg text-text-submain max-w-2xl mx-auto'>
            Find answers to common questions about TheChamps and how we can help
            you achieve your fitness goals.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className='space-y-4'>
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className='bg-secondary rounded-lg border border-tertiary overflow-hidden'
            >
              <button
                className='w-full px-6 py-4 text-left flex justify-between items-center hover:bg-tertiary transition-colors duration-200'
                onClick={() => toggleFAQ(faq.id)}
              >
                <span className='font-semibold text-lg'>{faq.question}</span>
                <svg
                  className={`w-6 h-6 transform transition-transform duration-200 ${
                    openId === faq.id ? 'rotate-180' : ''
                  } text-accent`}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M19 9l-7 7-7-7'
                  />
                </svg>
              </button>
              <div
                className={`px-6 py-4 bg-tertiary transition-all duration-200 ${
                  openId === faq.id ? 'block' : 'hidden'
                }`}
              >
                <p className='text-text-submain'>{faq.answer}</p>
                {faq.id === 4 && (
                  <div className='mt-4 flex flex-col md:flex-row justify-center items-center gap-16'>
                    <div className='text-center'>
                      <h4 className='text-lg font-semibold mb-2'>
                        iOS Instructions
                      </h4>
                      <img
                        src='https://static-resource.thechamps.app/img/tutorial/add-to-home-ios.png'
                        alt='Add to Home Screen (iOS)'
                        className='w-full md:w-72'
                      />
                    </div>
                    <div className='text-center'>
                      <h4 className='text-lg font-semibold mb-2'>
                        Android Instructions
                      </h4>
                      <img
                        src='https://static-resource.thechamps.app/img/tutorial/add-to-home-aos.png'
                        alt='Add to Home Screen (Android)'
                        className='w-full md:w-72'
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Contact Support */}
        <div className='mt-12 text-center'>
          <p className='text-text-submain mb-8'>
            Still have questions? We're here to help!
          </p>
          <a
            href='mailto:support@thechamps.app'
            className='bg-accent hover:bg-accentHover text-black font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105'
          >
            Contact Support
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
